var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 73,
    viewBox: "0 0 77 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32812 36.6786C2.32812 38.227 2.5098 39.6651 2.70797 41.1938C2.92277 42.8508 2.87951 44.5791 2.87951 46.2481C2.87951 49.3667 2.92271 52.497 2.7631 55.6093C2.50799 60.584 2.4384 65.5465 2.4384 70.5334",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77539 28.9592C1.77539 29.1552 1.80602 29.2411 1.88567 29.4003",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8516 2.25623C61.3336 7.55882 61.6187 13.0492 61.6187 18.3666C61.6187 24.8639 61.9101 31.4739 61.3488 37.9291C60.3963 48.8829 61.363 59.5952 61.363 70.5333",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7871 37.2898C49.1009 37.2898 51.5483 37.3985 53.7484 36.7215C55.9347 36.0488 58.9208 36.5226 61.2211 36.5226C63.7489 36.5226 66.2252 36.2669 68.779 36.2669C70.7923 36.2669 72.6473 36.5226 74.6605 36.5226",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/IT.3a33b0df7206d556733fb2b699f3e437.svg";
export { ForwardRef as ReactComponent };